export default __webpack_public_path__ + "4fb8bc127068510a9bb4ba1b007c52f5.svg";